import { IGroupScope } from "ts/interfaces/Group"

export const groupScopeChipSx: Record<
  IGroupScope,
  { bgcolor: string; color: string }
> = {
  CLASS: { bgcolor: "mockup.neutral95", color: "mockup.neutral20" },
  SCHOOL: { bgcolor: "mockup.success90", color: "mockup.success50" },
}
